import MicroModal from 'micromodal';
import ApplicationController from '../application_controller';

// Connects to data-controller="landing-pages--modal"
export default class extends ApplicationController {
  static values = {
    referer: String,
  };

  connect() {
    super.connect();
    this.show();
  }

  show() {
    MicroModal.show('modal-window', {
      onClose: () => {
        window.history.replaceState('', '', this.refererValue);
      },
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  }

  close() {
    window.history.replaceState('', '', this.refererValue);
    MicroModal.close('modal-window');
  }
}
